import tinycolor from 'tinycolor2';

const getHSLColor = (color: string, s = 80, l = 10) => {
  const { h } = tinycolor(color).toHsl();

  return tinycolor(`hsl(${h}, ${s}, ${l})`).toHexString();
};

export default getHSLColor;
